<template>

    <!-- FULL MONITOR -->

    <div v-if="variant === 'full'" class="bedrock-monitor" :style="scaleStyle">

        <div class="core">

            <div v-for="node in nodes" :key="node.key" class="node" :class="state[node.key] ? 'active' : 'inactive'"
                :style="node.style">
                {{ node.key }}
            </div>

        </div>

        <div class="result">

            <div v-if="harm.value > 0" class="harm">
                HarmLevel: {{ harm.value }}
            </div>

            <div class="snapshot">
                {{ snapshot.value ? "SNAPSHOT REQUIRED" : "runtime safe" }}
            </div>

        </div>

    </div>
    <div v-else-if="variant === 'stack'" class="bedrock-monitor-stack">

        <div class="bedrock-stack-indicator"
            :class="snapshot.value ? 'snapshot' : (harm.value > 0 ? 'warning' : 'healthy')">
        </div>

        <div class="bedrock-stack-text">

            <span class="bedrock-stack-title">
                Bedrock
            </span>

            <span class="bedrock-stack-state">

                <template v-if="snapshot.value">
                    snapshot required
                </template>

                <template v-else-if="harm.value > 0">
                    impact detected
                </template>

                <template v-else>
                    runtime safe
                </template>

            </span>

        </div>

    </div>

    <!-- INLINE SYSTEMBAR MONITOR -->

    <div v-else class="bedrock-monitor-inline">

        <span v-for="node in nodes" :key="node.key" class="bedrock-inline-node"
            :class="state[node.key] ? 'active' : 'inactive'" :title="node.key" />

    </div>

</template>
<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue"
import { getBedrockHealth } from "@/domain/system/bedrock.api"

const props = defineProps({

    impact: {
        type: Object,
        default: null
    },

    size: {
        type: Number,
        default: 400
    },
    variant: {
        type: String,
        default: "full"
    },
    auto: {
        type: Boolean,
        default: true
    },

    interval: {
        type: Number,
        default: 8000
    }

})

const internalImpact = ref(null)
let timer = null

async function load() {

    try {

        const res = await getBedrockHealth()
        internalImpact.value = { ...res.impact }


    } catch (e) {

        console.warn("Bedrock health failed", e)

    }

}

onMounted(() => {

    if (props.auto && !props.impact) {

        load()

        timer = setInterval(load, props.interval)

    }

})

onUnmounted(() => {

    if (timer) clearInterval(timer)

})

const state = computed(() => {

    return props.impact || internalImpact.value || {}

})
console.log("BedrockMonitor state", state.value)
const nodes = [

    { key: "identity", style: { top: "0%", left: "37.5%" } },
    { key: "relation", style: { top: "20%", left: "75%" } },
    { key: "entity", style: { top: "55%", left: "75%" } },
    { key: "lifecycle", style: { top: "75%", left: "37.5%" } },
    { key: "command", style: { top: "55%", left: "0%" } },
    { key: "event", style: { top: "20%", left: "0%" } }

]

const harm = computed(() => {

    return Object.values(state.value).filter(v => v).length

})
console.log("BedrockMonitor harm", harm.value)
const snapshot = computed(() => harm.value >= 4)

const scaleStyle = computed(() => ({

    width: props.size + "px"

}))
</script>